import { render, staticRenderFns } from "./VirtualScroller2.vue?vue&type=template&id=4ffe408e&scoped=true"
import script from "./VirtualScroller2.vue?vue&type=script&lang=js"
export * from "./VirtualScroller2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe408e",
  null
  
)

export default component.exports